import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconRuler: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="ruler"><g clipPath="url(#clip0_6508_53969)"><path d="M11.5 11.5L8.875 8.875L5.375 12.375L7 14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.375 5.375L8.875 8.875" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M14 7L12.375 5.375L16 1.75L22.25 8L8 22.25L1.75 16L5.375 12.375" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></g><defs><clipPath id="clip0_6508_53969"><rect width="24" height="24" fill="white"/></clipPath></defs></CentralIconBase>;
};

export default IconRuler;
